import api from "./client";

export const listSignalTypes = async () => {
  const { data } = await api.get("/signaltypes/");
  return data;
};

export const getSignalType = async (id) => {
  const { data } = await api.get(`/signaltypes/${id}`);
  return data;
};

export const createSignalType = async (payload) => {
  const { data } = await api.post("/signaltypes/", payload);
  return data;
};

export const updateSignalType = async (id, payload) => {
  const { data } = await api.put(`/signaltypes/${id}`, payload);
  return data;
};

export const deleteSignalType = async (id) => {
  const { data } = await api.delete(`/signaltypes/${id}`);
  return data;
};
